<template>
  <div>
    <b-card>
      <b-form inline style="flex-flow: unset">
        <label class="mr-sm-2" for="subs">Тип</label>
        <b-form-select
          class="mb-2 mr-sm-2 mb-sm-0 custom-icon"
          v-model="group"
          :options="{
            4: 'Все',
            '0': 'Газы',
            1: 'Жидкости',
            //'2': 'Пыли',
            2: 'Твердые вещества',
            '5': 'Пользовательские',
          }"
          id="subs"
        >
        </b-form-select>
        <label class="mr-sm-2" for="substances">Вещество</label>
        <multiselect
          select-label="Нажмите enter"
          selected-label="Выбрано"
          deselect-label="Нажмите enter"
          id="substances"
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="selected"
          track-by="id"
          label="name"
          placeholder="Выберите вещество"
          :options="substancesList"
          :searchable="true"
          :allow-empty="false"
          group-values="subs"
          group-label="type"
        >
          <span slot="noResult">Совпадений не найдено. Измените поисковый запрос.</span>
        </multiselect>
        <b-btn
          @click="
            substance = { isNewRecord: true, type: 2 };
            selected = {};
          "
          class="success"
          >Новое вещество</b-btn
        >
      </b-form>
    </b-card>
    <b-row>
      <b-col>
        <b-card-group deck>
          <b-card header="Выбрать из объекта">
            <b-list-group>
              <b-list-group-item
                v-for="substance in objectSubstances"
                :key="substance.id"
                href="#"
                @click="selectById(substance.id, substance.type)"
                :active="selected && selected.id == substance.id"
              >
                <h5 style="display: inline">
                  {{ findById(substance.id, substance.type) }} -
                  <b-badge :key="object.name" v-for="object in substance.objects" class="m-1">{{
                    object.name
                  }}</b-badge>
                </h5>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col>
        <b-card v-if="selected || (substance && substance.isNewRecord)">
          <template v-slot:header>
            <h6 class="mb-0" style="display: inline" v-if="substance && substance.isNewRecord">Новое вещество</h6>
            <h6 style="display: inline" v-else>Редактирование "{{ selected.name }}"</h6>
            <b-btn
              class="pull-right"
              v-on:click.prevent="
                $refs.sub_remove_modal.sub_id = substance.id;
                $refs.sub_remove_modal.sub_type = substance.type;
              "
              v-b-modal.sub_remove_modal
              size="sm"
              v-if="substance && substance.user_id"
              variant="danger"
              >Удалить</b-btn
            >
          </template>
          Тип
          <b-form-select
            class="custom-icon"
            v-model="type"
            :options="{
              1: 'Газ',
              2: 'Жидкость',
              3: 'Твердое вещество',
            }"
            id="subs"
          >
          </b-form-select>
          <Gas
            v-if="type == 1"
            :objectSubstances="objectSubstances"
            :substance="substance"
            @save="save($event)"
            :validator="validator"
          ></Gas>
          <Liquid
            v-if="type == 2"
            :objectSubstances="objectSubstances"
            :substance="substance"
            @save="save($event)"
            :validator="validator"
          ></Liquid>
          <Solid v-if="type == 3" :substance="substance" @save="save($event)"></Solid>
          <span v-if="type == 4" :substance="substance" @save="save($event)">Редактор пылей не реализован</span>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="sub_remove_modal" hide-footer id="sub_remove_modal" title="Удалить">
      <div class="d-block text-center">
        <h3>Вы действительно хотите удалить это вещество?</h3>
      </div>
      <b-btn
        class="mt-3 btn-outline"
        variant="danger"
        block
        @click="
          remove($refs.sub_remove_modal.sub_id, $refs.sub_remove_modal.sub_type);
          $refs.sub_remove_modal.hide();
        "
        >Удалить
      </b-btn>
    </b-modal>
  </div>
</template>

<style scoped>
.custom-icon {
  background: #fff url("../../../assets/icons/caret-down-fill.svg") right 0.75rem center/12px 16px no-repeat;
}
</style>

<script>
import Multiselect from "vue-multiselect";
import Liquid from "./Liquid";
import Gas from "./Gas";
import Solid from "./Solid";
export default {
  name: "substances",
  props: {
    installations: Array,
    pipelines: Array,
    substanceToShow: Object,
    proj_id: Number,
  },
  data() {
    return {
      substances: [],
      substancesList: [],
      substance: null,
      selected: null,
      group: 0,
      type: 1, // Тип для новых веществ и изменения типа старых
      validator: {},
    };
  },
  components: {
    Multiselect,
    Liquid,
    Gas,
    Solid,
  },
  watch: {
    group() {
      if (this.group == 5) {
        const arr = [];
        for (let i = 0; i < 4; i++) {
          if (this.substances[i]) {
            arr[i] = JSON.parse(JSON.stringify(this.substances[i]));
            arr[i].subs = arr[i].subs.filter(function (val) {
              return val.user_id > 0;
            });
          }
        }
        this.substancesList = arr;
      } else if (this.group == 4) {
        this.substancesList = this.substances;
      } else {
        const arr = [];
        arr[0] = this.substances[this.group];
        this.substancesList = arr;
      }
    },
    selected() {
      this.getSubstance();
    },
  },
  computed: {
    objectSubstances() {
      const substances = [];
      for (const i in this.installations) {
        if (this.installations[i].obj_type == 21) {
          if (this.installations[i].hoses) {
            for (const hose of this.installations[i].hoses) {
              if (hose.substance) {
                const index = substances.findIndex((cur) => cur.id == hose.substance);
                if (index != -1) {
                  substances[index].objects.push({
                    name: this.installations[i].name,
                    id: this.installations[i].id,
                    type: this.installations[i].obj_type,
                  });
                } else {
                  substances.push({
                    id: hose.substance,
                    type: 2,
                    objects: [
                      {
                        name: this.installations[i].name,
                        id: this.installations[i].id,
                        type: this.installations[i].obj_type,
                      },
                    ],
                  });
                }
              } else {
                substances.push({
                  id: 0,
                  type: 1,
                  objects: [
                    {
                      name: this.installations[i].name,
                      id: this.installations[i].id,
                      type: this.installations[i].obj_type,
                    },
                  ],
                });
              }
            }
          }
        } else {
          if (this.installations[i].substance0) {
            const index = substances.findIndex((cur) => cur.id == this.installations[i].substance0.id);
            if (index != -1) {
              substances[index].objects.push({
                name: this.installations[i].name,
                id: this.installations[i].id,
                type: this.installations[i].obj_type,
              });
            } else {
              substances.push({
                id: this.installations[i].substance0.id,
                type: this.installations[i].substance0.type,
                objects: [
                  {
                    name: this.installations[i].name,
                    id: this.installations[i].id,
                    type: this.installations[i].obj_type,
                  },
                ],
              });
            }
          } else {
            substances.push({
              id: 0,
              type: 1,
              objects: [
                {
                  name: this.installations[i].name,
                  id: this.installations[i].id,
                  type: this.installations[i].obj_type,
                },
              ],
            });
          }
        }
      }
      for (const i in this.pipelines) {
        if (this.pipelines[i].substance0) {
          const index = substances.findIndex((cur) => cur.id == this.pipelines[i].substance0.id);
          if (index != -1) {
            substances[index].objects.push({
              name: this.pipelines[i].name,
              id: this.pipelines[i].id,
              type: this.pipelines[i].obj_type,
            });
          } else {
            substances.push({
              id: this.pipelines[i].substance0.id,
              type: this.pipelines[i].substance0.type,
              objects: [{ name: this.pipelines[i].name, id: this.pipelines[i].id, type: this.pipelines[i].obj_type }],
            });
          }
        } else {
          substances.push({
            id: 0,
            type: 1,
            objects: [{ name: this.pipelines[i].name, id: this.pipelines[i].id, type: this.pipelines[i].obj_type }],
          });
        }
      }
      return substances;
    },
  },
  methods: {
    remove(id, type) {
      this.$http
        .get("risk/substance/remove?id=" + id + "&type=" + type)
        .then(() => {
          const key = this.substances[type - 1].subs.findIndex((cur) => cur.id == id);
          this.substances[type - 1].subs.splice(key, 1);
          this.selected = null;
        })
        .catch(() => {
          alert("Возникла ошибка");
        });
    },
    selectById(id, type) {
      const data = this.substances[type - 1].subs.find((cur) => cur.id == id);
      if (data) {
        this.selected = data;
      }
    },
    findById(id, type) {
      if (this.substances[type - 1]) {
        const data = this.substances[type - 1].subs.find((cur) => cur.id == id);
        if (data) {
          return data.name;
        } else {
          return "вещество не найдено";
        }
      }
    },
    loadSubstances() {
      this.$http.get("risk/substance/substances").then((response) => {
        response.data.forEach((group, i) => {
          const sorted = group.subs.sort(this.sortArray);
          response.data[i].subs = sorted;
        });
        this.$set(this, "substances", response.data);
        this.$set(this.substancesList, this.type, this.substances[this.type - 1]);
        if (this.substanceToShow && this.substanceToShow.id && this.substanceToShow.type) {
          this.selectById(this.substanceToShow.id, this.substanceToShow.type);
          this.$emit("update:substanceToShow", {});
        }
      });
    },
    getSubstance() {
      if (this.selected.id) {
        this.$http
          .get("risk/substance/substance?id=" + this.selected.id + "&type=" + this.selected.type)
          .then((response) => {
            this.substance = response.data;
            this.group = response.data.type - 1;
            this.type = response.data.type;
          });
      }
    },
    save(model) {
      if (!model.id) {
        const data = {};
        Object.assign(data, model);
        this.$http
          .post(
            "risk/substance/create?type=" + this.type + "&proj_id=" + this.proj_id + "&parentId=" + model.parentId,
            data
          )
          .then((response) => {
            this.substances[this.type - 1].subs.push(response.data);
            if (data.replaceIds) {
              for (let objId of data.replaceIds) {
                const installation = this.installations.find((el) => el.id == objId.objId);
                if (installation.obj_type == 21) {
                  for (const hose of installation.hoses) {
                    if (hose.substance == model.parentId) {
                      hose.substance = response.data.id;
                    }
                  }
                } else {
                  installation.substance = response.data.id;
                  installation.substance0 = response.data;
                }
              }
            }
            this.$nextTick(() => {
              this.selectById(response.data.id, response.data.type);
            });
            this.$set(this, "validator", {});
          })
          .catch((e) => {
            this.$set(this, "validator", e.response.data || {});
          });
      } else {
        if (model.user_id == null && !this.$auth.user().isAdmin) {
          if (model.name == this.substance.name) {
            model.name += " (копия)";
          }
          if (
            !confirm(
              "Стандартное вещество нельзя изменить, поэтому будет создана копия вещества с заданными параметрами: " +
                model.name
            )
          ) {
            return false;
          }
        }
        const data = {};
        Object.assign(data, model);
        this.$http
          .post("risk/substance/update?id=" + model.id + "&type=" + this.type, data)
          .then((response) => {
            if (model.user_id) {
              for (const i in this.substances) {
                const index = this.substances[i].subs.findIndex((cur) => cur.id == model.id);
                this.$set(this.substances[i].subs, index, response.data);
              }
            } else {
              this.substances[this.type - 1].subs.push(response.data);
              this.$nextTick(() => {
                this.selectById(response.data.id, response.data.type);
              });
            }
            this.$set(this, "validator", {});
          })
          .catch((e) => {
            this.$set(this, "validator", {});
            this.$set(this, "validator", e.response.data);
            this.$refs.form.validate();
          });
      }
    },
    sortArray(x, y) {
      if (!x.name || !y.name) return 0;
      if (x.name.toLowerCase() < y.name.toLowerCase()) {
        return -1;
      }
      if (x.name.toLowerCase() > y.name.toLowerCase()) {
        return 1;
      }
      return 0;
    },
  },
  mounted() {
    this.loadSubstances();
  },
};
</script>
